import { ChangeLogDto } from "@libs/api/dtos/index.ts";

export interface XeroTenantInfoDto {
  tenantId: string | undefined;
  tenants: XeroTenantDto[];
}

export interface XeroTenantDto {
  tenantId: string;
  tenantName: string;
  tenantType: string;
}

export interface XeroSettingsDto {
  targetTenantId: string;
  startDate?: string;
  hasSynced: boolean;
  changeLog: ChangeLogDto;
  eTag?: string;
}

export interface XeroSettingsUpdateDto
  extends Omit<XeroSettingsDto, "hasSynced"> {}

export interface XeroSettingsAddDto
  extends Omit<XeroSettingsDto, "eTag" | "changeLog" | "hasSynced"> {}

interface XeroFinancialSyncBaseRequestDto {
  id: string;
  targetTenantId: string;
  status?: string;
  changeLog: ChangeLogDto;
  eTag?: string;
}

interface XeroFinancialStatusDetails {
  message?: string;
  exceptionMessage?: string;
  stackTrace?: string;
}

export interface XeroFinancialSyncAllRequestDto
  extends XeroFinancialSyncBaseRequestDto {
  startDate: Date;
}

export interface XeroFinancialSyncGetRequestDto
  extends XeroFinancialSyncBaseRequestDto {
  syncGetType?: string;
  statusDetails?: XeroFinancialStatusDetails[];
}

export interface XeroFetchedAccountDto {
  id: string;
  code?: string;
  name?: string;
  type?: string;
  status?: string;
  bankAccountNumber?: string;
  enablePaymentsToAccount?: boolean;
}

export interface XeroAccountMappingsDto {
  id: string;
  targetTenantId?: string;
  providerId?: string;
  invoiceAccountId?: string;
  paymentAccountId?: string;
  unallocatedAccountId?: string;
  changeLog: ChangeLogDto;
  eTag: string;
}

export interface XeroAccountMappingsAddDto
  extends Omit<XeroAccountMappingsDto, "id" | "eTag" | "changeLog"> {}

export interface XeroFinancialSyncGetRequestArgsDto {
  targetTenantId: string;
}

export enum XeroFinancialSyncGetRequestStatusType {
  PENDING = "PENDING",
  INTERNALFAILURE = "INTERNALFAILURE",
  COMPLETED = "COMPLETED"
}
